
import { esPendiente, esAlertaSonable, ordenarPorCreacion, idSOS } from "./datos_sos";

export const MS_ALERTA_RECIENTE = 2 * 60000;

export const VENTANA_POR_NIT = 3;

export const crearMemoriaVigilancia = () => ({
  recordadas: new Map(),
  idsNuevas: new Set(),
  conocidas: new Set(),
  esPrimerCalculo: true,
});

export const sembrarConocidas = (memoria, alertas, msRecientes = MS_ALERTA_RECIENTE) => {
  const limite = Date.now() - msRecientes;

  (alertas || []).forEach((alerta) => {
    if (esAlertaSonable(alerta) && alerta._creacion_ms >= limite) return;
    memoria.conocidas.add(idSOS(alerta));
  });
};

export const calcularVigilancia = (memoria, alertasEnVentana) => {
  const enVentana = ordenarPorCreacion(alertasEnVentana || []);
  const idsEnVentana = new Set(enVentana.map(idSOS));

  enVentana.forEach((alerta) => {
    const id = idSOS(alerta);
    if (esPendiente(alerta)) memoria.recordadas.set(id, alerta);
    else memoria.recordadas.delete(id);
  });

  const fueraDeVentana = [...memoria.recordadas.entries()]
    .filter(([id]) => !idsEnVentana.has(id))
    .map(([, alerta]) => alerta);

  const pendientes = ordenarPorCreacion([
    ...enVentana.filter(esPendiente),
    ...fueraDeVentana,
  ]);

  const recienLlegadas = enVentana.filter(
    (a) => esAlertaSonable(a) && esPendiente(a) && !memoria.conocidas.has(idSOS(a))
  );

  idsEnVentana.forEach((id) => memoria.conocidas.add(id));
  recienLlegadas.forEach((a) => memoria.idsNuevas.add(idSOS(a)));

  const nuevas = pendientes.filter((a) => memoria.idsNuevas.has(idSOS(a)));

  let aviso = null;
  if (recienLlegadas.length) {
    aviso = { tipo: "nueva", alertas: recienLlegadas };
  } else if (memoria.esPrimerCalculo && pendientes.length) {
    aviso = { tipo: "recordatorio", alertas: pendientes };
  }

  memoria.esPrimerCalculo = false;

  return { pendientes, nuevas, recienLlegadas, fueraDeVentana, aviso };
};

export const olvidarAlerta = (memoria, id) => {
  memoria.recordadas.delete(id);
  memoria.idsNuevas.delete(id);
};
